import { useMemo } from 'react';

export const findCategoryPath = (categories, targetNode) => {
  const findPath = (categories, target, currentPath = []) => {
    for (let category of categories) {
      if (category.id === target.id) {
        return [...currentPath, category];
      }
      if (category.subcategories) {
        const found = findPath(category.subcategories, target, [...currentPath, category]);
        if (found) return found;
      }
    }
    return null;
  };

  return findPath(categories, targetNode);
};

export const useNodePath = (data, targetNode) => {
  const path = useMemo(() => {
    if (!targetNode || !data?.subcategories) {
      return {
        fullPath: [{ name: 'All' }],
        pathIds: []
      };
    }

    const categoryPath = findCategoryPath(data.subcategories, targetNode);
    
    return {
      fullPath: [{ name: 'All' }, ...(categoryPath || [])],
      pathIds: data.id ? [data.id, ...(categoryPath ? categoryPath.map(node => node.id) : [])] : []
    };
  }, [data?.subcategories, data?.id, targetNode]);

  return path;
}; 